import styled from '@emotion/styled'
import { SlideDown } from 'view/components/panels/slidedown'
import 'view/components/panels/slidedown/slidedown.css'
import * as constants from 'view/styles/constants'

export const DataGridFiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  padding: 10px 10px 0;
  min-height: 30px;
  z-index: 3;
  position: relative;
  background-color: ${constants.CORE_PRIMARY_1};
`

export const FieldsWrapper = styled.div`
  display: flex;
  align-items: center;
  &:not(:last-child) {
    margin-bottom: 5px;
  }
  & > * {
    margin-right: 10px;
  }
  & > input,
  & > div {
    width: 165px;
  }
  & > label:first-of-type {
    min-width: 123px;
  }

  label {
    display: flex;
    align-items: center;
    min-width: 165px;
    > div {
      margin-left: 10px;
    }
  }
`

export const AdvancedFieldsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  > div {
    padding-right: 10px;
    width: 25%;
    label {
      font-size: inherit;
      font-weight: inherit;
      min-width: 123px;
      margin-right: 10px;
    }

    align-items: center;
    flex-direction: row;
  }

  &:not(:last-child) {
    padding-bottom: 5px;
  }
`

export const ToolbarToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const FiltersSlideDown = styled(SlideDown)`
  margin-top: 5px;
  display: flex;
  align-items: flex-end;
`
